import * as React from 'react';
import { useContext } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { Grid } from '@material-ui/core';

interface Props {

};


const Home: React.FC<Props> = (prop: Props) => {

    const { user } = useContext(AuthContext);



    return (
        <Grid container direction="row" justify="flex-start" alignItems="stretch">
            <Grid item>Insights Home { user.displayName }</Grid>

        </Grid>
    )
}

export default Home;